
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as entity from '../entity'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * ErrorCode enum
 */
class ErrorCode {
  /**
   * Initialize enum with a given value
   * @param {ErrorCode|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof ErrorCode) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!ErrorCode}
   * @param {!ErrorCode} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ErrorCode)) {
      throw new TypeError('Instance of ErrorCode is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!ErrorCode}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!ErrorCode}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === ErrorCode.INTERNAL_ERROR.value) {
      return 'INTERNAL_ERROR'
    }
    if (this.value === ErrorCode.TOKEN_INVALID.value) {
      return 'TOKEN_INVALID'
    }
    if (this.value === ErrorCode.TOKEN_EXPIRED.value) {
      return 'TOKEN_EXPIRED'
    }
    if (this.value === ErrorCode.TOKEN_NOT_FOUND.value) {
      return 'TOKEN_NOT_FOUND'
    }
    if (this.value === ErrorCode.TOKEN_THROTTLING.value) {
      return 'TOKEN_THROTTLING'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!ErrorCode}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!ErrorCode}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!ErrorCode} Created enum
   */
  static fromObject (other) {
    return new ErrorCode(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
ErrorCode.INTERNAL_ERROR = new ErrorCode(1 + 0)
// noinspection PointlessArithmeticExpressionJS
ErrorCode.TOKEN_INVALID = new ErrorCode(100 + 0)
// noinspection PointlessArithmeticExpressionJS
ErrorCode.TOKEN_EXPIRED = new ErrorCode(100 + 1)
// noinspection PointlessArithmeticExpressionJS
ErrorCode.TOKEN_NOT_FOUND = new ErrorCode(100 + 2)
// noinspection PointlessArithmeticExpressionJS
ErrorCode.TOKEN_THROTTLING = new ErrorCode(100 + 3)

export { ErrorCode };

/**
 * Fast Binary Encoding ErrorCode field model
 */
class FieldModelErrorCode extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelErrorCode}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelErrorCode}
   * @param {ErrorCode=} defaults Default value, defaults is new ErrorCode()
   * @returns {!ErrorCode} Result value
   */
  get (defaults = new ErrorCode()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new ErrorCode(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelErrorCode}
   * @param {!ErrorCode} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelErrorCode };
